<template>
  <div>
    <div
      style="
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        padding-bottom: 1rem;
        padding-top: 1rem;
        background-color: #000;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 1rem;
      "
    >
      <div class="mr-2">
        <img
          src="data:image/png;base64,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"
          width="32"
          height="32"
        />
      </div>

      <h3 style="color: white">Frotix | Formulário instalação de acessórios</h3>
    </div>

    <form id="osForm" class="mx-auto col-sm-8 col-lg-12" @submit.prevent>
      <h4 style="color: #000">SOLICITANTE</h4>

      <div class="row mb-4">
        <div
          class="form-group col-lg-12"
          :class="{ 'has-error': errors.has('complete_name') }"
        >
          <label for="complete_name">{{ $t("complete_name") }}</label>
          <input
            id="complete_name"
            type="complete_name"
            name="complete_name"
            class="form-control"
            :placeholder="$t('ph_complete_name')"
            v-model="applicant.name"
            v-validate="'required'"
            @input="applicant.name = applicant.name.toUpperCase()"
          />

          <small
            v-show="errors.has('complete_name')"
            class="form-text text-muted text-left"
          >
            {{ errors.first("complete_name") }}
          </small>
        </div>

        <div
          class="form-group col-md-4"
          :class="{ 'has-error': errors.has('email') }"
        >
          <label for="email">{{ $t("email") }}</label>
          <input
            id="email"
            type="email"
            name="email"
            class="form-control"
            :placeholder="$t('type_email')"
            v-model="applicant.email"
            v-validate="'required|email'"
          />

          <small
            v-show="errors.has('email')"
            class="form-text text-muted text-left"
          >
            {{ errors.first("email") }}
          </small>
        </div>

        <div
          class="form-group col-md-4"
          :class="{ 'has-error': errors.has('cpf') }"
        >
          <label for="cpf">{{ $t("cpf") }}</label>
          <the-mask
            id="cpf"
            type="phone"
            name="cpf"
            class="form-control"
            :placeholder="$t('ph_cpf')"
            v-model="applicant.cpf"
            v-validate="'required|cpf'"
            :mask="['###.###.###-##']"
          />

          <small
            v-show="errors.has('cpf')"
            class="form-text text-muted text-left"
          >
            {{ errors.first("cpf") }}
          </small>
        </div>

        <div
          class="form-group col-md-4"
          :class="{ 'has-error': errors.has('cargo') }"
        >
          <label for="cargo">{{ $t("cargo") }}</label>
          <input
            id="cargo"
            type="cargo"
            name="cargo"
            class="form-control"
            :placeholder="$t('ph_cargo')"
            v-model="applicant.cargo"
            v-validate="'required'"
            @input="applicant.cargo = applicant.cargo.toUpperCase()"
          />

          <small
            v-show="errors.has('cargo')"
            class="form-text text-muted text-left"
          >
            {{ errors.first("cargo") }}
          </small>
        </div>
      </div>

      <h4 style="color: #000">DADOS DA EMPRESA</h4>

      <div class="row mb-4">
        <div
          class="form-group col-lg-6"
          :class="{ 'has-error': errors.has('social_reason') }"
        >
          <label for="social_reason">{{ $t("social_reason") }}</label>
          <input
            id="social_reason"
            type="social_reason"
            name="social_reason"
            class="form-control"
            :placeholder="$t('type_social_reason')"
            v-model="company.name"
            v-validate="'required'"
            @input="company.name = company.name.toUpperCase()"
          />

          <small
            v-show="errors.has('social_reason')"
            class="form-text text-muted text-left"
          >
            {{ errors.first("social_reason") }}
          </small>
        </div>

        <div
          class="form-group col-lg-6"
          :class="{ 'has-error': errors.has('cnpj') }"
        >
          <label for="cnpj">{{ $t("cnpj") }}</label>
          <the-mask
            id="cnpj"
            type="phone"
            name="cnpj"
            class="form-control"
            :placeholder="$t('ph_cnpj')"
            v-model="company.cnpj"
            @input="company.cnpj = company.cnpj.toUpperCase()"
            v-validate="'required|cnpj_alphanumeric'"
            :mask="'XX.XXX.XXX/XXXX-##'"
          />

          <small
            v-show="errors.has('cnpj')"
            class="form-text text-muted text-left"
          >
            {{ errors.first("cnpj") }}
          </small>
        </div>
      </div>

      <h4 style="color: #000">DADOS DO SERVIÇO (OPCIONAL)</h4>

      <div class="row mb-4">
        <div class="form-group col-lg-12">
          <div>
            <label for="input-with-list">{{ $t('ph_service_local') }}</label>

            <b-form-input
              list="input-list"
              id="input-with-list"
              v-model="service.address"
              :placeholder="$t('ph_service_local')"
            />

            <b-form-datalist
              id="input-list"
              :options="addresses"
            />
          </div>
        </div>

        <div
          class="form-group col-lg-6"
          :class="{ 'has-error': errors.has('reference_point') }"
        >
          <label for="reference_point">{{ $t("reference_point") }}</label>
          <input
            id="reference_point"
            type="reference_point"
            name="reference_point"
            class="form-control"
            :placeholder="$t('ph_reference_point')"
            v-model="service.referencePoint"
            @input="service.referencePoint = service.referencePoint.toUpperCase()"
          />
        </div>

        <div
          class="form-group col-lg-6"
          :class="{ 'has-error': errors.has('service_date') }"
        >
          <label for="service_date">{{ $t("service_date") }}</label>
          <input
            id="service_date"
            type="datetime-local"
            name="service_date"
            class="form-control"
            :placeholder="$t('ph_service_date')"
            v-model="service.datetimeService"
          />
        </div>
      </div>
    </form>

    <div
      class="mx-auto col-sm-8 col-lg-12 mb-4"
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        align-content: center;
      "
    >
      <h4 style="color: #000">RESPONSÁVEIS PELO ACOMPANHAMENTO DO SERVIÇO</h4>

      <button
        type="button"
        class="btn btn-md btn-primary btn-circle light-bottom-shadow"
        style="color: #000"
        @click="showModalAddResponsible"
      >
        <i class="fas fa-plus fa-md" />
      </button>
    </div>

    <div class="mx-auto col-sm-8 col-lg-12 pb-3" style="overflow-x: auto">
      <table class="table bg-white">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Email</th>
            <th>Telefone</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(responsibleItem, index) in allResponsible" :key="index">
            <td>{{ responsibleItem.name }}</td>
            <td>{{ responsibleItem.email }}</td>
            <td>{{ responsibleItem.phone }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm"
                @click="() => removeResponsible(index)"
              >
                <i class="fas fa-trash" style="color: red" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="mx-auto col-sm-8 col-lg-12 mb-4"
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        align-content: center;
      "
    >
      <h4 style="color: #000">VEÍCULO(S)</h4>

      <button
        type="button"
        class="btn btn-md btn-primary btn-circle light-bottom-shadow"
        style="color: #000"
        @click="showModalAddVehicle"
      >
        <i class="fas fa-plus fa-md" />
      </button>
    </div>

    <div class="mx-auto col-sm-8 col-lg-12 pb-3" style="overflow-x: auto">
      <table class="table bg-white">
        <thead>
          <tr>
            <th>Placa</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Ano</th>
            <th>Bloqueio</th>
            <th>Acessórios</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(vehicleItem, index) in allVehicles" :key="index">
            <td>{{ vehicleItem.plate }}</td>
            <td>{{ vehicleItem.brand }}</td>
            <td>{{ vehicleItem.model }}</td>
            <td>{{ vehicleItem.year }}</td>
            <td>{{ vehicleItem.block }}</td>
            <td>{{ vehicleItem.acessories }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm"
                @click="() => removeVehicle(index)"
              >
                <i class="fas fa-trash" style="color: red" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mx-auto col-sm-8 col-lg-12 pb-3">
      <h4 style="color: red" class="mb-2">ATENÇÃO:</h4>

      <p class="text-justify font-bold ml-4" style="color: #000">
        * O não comparecimento de um ou mais veículos no endereço, data e hora
        agendados poderá acarretar em cobrança adicional de visita
        improdutiva.
      </p>
    </div>

    <!-- MODAL ADD RESPONSIBLE -->
    <div
      class="modal fade"
      id="modalAddResponsible"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalAddResponsibleLabel"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content bg-muted">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAddResponsibleLabel">
              Responsável
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Fechar"
            >
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row mb-4">
              <div
                class="form-group col-lg-12"
                :class="{ 'has-error': errors.has('name') }"
              >
                <label for="name">{{ $t("name") }}</label>
                <input
                  id="name"
                  type="name"
                  name="name"
                  class="form-control"
                  :placeholder="$t('name')"
                  v-model="responsible.name"
                  v-validate="'required'"
                  @input="responsible.name = responsible.name.toUpperCase()"
                />

                <small
                  v-show="errors.has('name')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("name") }}
                </small>
              </div>

              <div
                class="form-group col-lg-12"
                :class="{ 'has-error': errors.has('responsible_email') }"
              >
                <label for="responsible_email">{{ $t("email") }}</label>
                <input
                  id="responsible_email"
                  type="email"
                  name="responsible_email"
                  class="form-control"
                  :placeholder="$t('email')"
                  v-model="responsible.email"
                  v-validate="'email'"
                />

                <small
                  v-show="errors.has('responsible_email')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("responsible_email") }}
                </small>
              </div>

              <div
                class="form-group col-lg-12"
                :class="{ 'has-error': errors.has('phone') }"
              >
                <label for="phone"
                  >{{ $t("phone") }} -
                  <small><em>Apenas números com DDD</em></small></label
                >
                <the-mask
                  id="phone"
                  type="text"
                  name="phone"
                  class="form-control"
                  :placeholder="$t('phone')"
                  v-model="responsible.phone"
                  v-validate="'required|min:12'"
                  :mask="['## #####-####', '## ####-####']"
                  masked
                />

                <small
                  v-show="errors.has('phone')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("phone") }}
                </small>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-form"
              data-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary btn-form"
              @click="addResponsible"
              data-dismiss="modal"
              style="color: #000"
              :disabled="!canAddResponsible"
            >
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ADD VEHICLE -->
    <div
      class="modal fade"
      id="modalAddVehicle"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalAddVehicleLabel"
    >
      <div
        class="modal-xl modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content bg-muted">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAddVehicleLabel">Veículo</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Fechar"
            >
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row mb-4">
              <div
                class="form-group col-md-12 col-lg-3"
                :class="{ 'has-error': errors.has('board') }"
              >
                <label for="board">{{ $t("board") }} - <small><em>XXX-9999 ou XXX-9X99</em></small></label>
                <input
                  id="board"
                  type="text"
                  name="board"
                  class="form-control"
                  :placeholder="$t('board')"
                  v-model="vehicle.plate"
                  v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
                  maxlength="8"
                  @input="vehicle.plate = vehicle.plate.toUpperCase()"
                />

                <small
                  v-show="errors.has('board')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("board") }}
                </small>
              </div>

              <div
                class="form-group col-md-12 col-lg-3"
                :class="{ 'has-error': errors.has('brand') }"
              >
                <label for="brand">{{ $t("brand") }}</label>
                <input
                  id="brand"
                  type="brand"
                  name="brand"
                  class="form-control"
                  :placeholder="$t('brand')"
                  v-model="vehicle.brand"
                  v-validate="'required'"
                  @input="vehicle.brand = vehicle.brand.toUpperCase()"
                />

                <small
                  v-show="errors.has('brand')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("brand") }}
                </small>
              </div>

              <div
                class="form-group col-md-12 col-lg-3"
                :class="{ 'has-error': errors.has('model') }"
              >
                <label for="model">{{ $t("model") }}</label>
                <input
                  id="model"
                  type="model"
                  name="model"
                  class="form-control"
                  :placeholder="$t('model')"
                  v-model="vehicle.model"
                  v-validate="'required'"
                  @input="vehicle.model = vehicle.model.toUpperCase()"
                />

                <small
                  v-show="errors.has('model')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("model") }}
                </small>
              </div>

              <div
                class="form-group col-md-12 col-lg-3"
                :class="{ 'has-error': errors.has('year') }"
              >
                <label for="year">{{ $t("year") }}</label>
                <input
                  id="year"
                  type="phone"
                  name="year"
                  class="form-control"
                  :placeholder="$t('year')"
                  v-model="vehicle.year"
                  v-validate="'required|digits:4'"
                />

                <small
                  v-show="errors.has('year')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("year") }}
                </small>
              </div>

              <div
                class="form-group col-md-12 col-lg-3"
                :class="{ 'has-error': errors.has('block') }"
              >
                <label for="block">{{ $t("block") }}</label>
                <Combobox
                  class="bg-white"
                  name="block"
                  :placeholder="$t('select_a_item')"
                  :options="['SIM', 'NÃO']"
                  v-model="vehicle.block"
                  v-validate="'required'"
                  :hasErrors="errors.has('block')"
                  :initial-value="vehicle.block"
                />

                <small
                  v-show="errors.has('block')"
                  class="form-text text-muted text-left"
                >
                  {{ errors.first("block") }}
                </small>
              </div>

              <div class="form-group col-md-12 col-lg-9">
                <label for="acessories">{{ $t("acessories") }}</label>
                <textarea
                  id="acessories"
                  name="acessories"
                  class="form-control"
                  :placeholder="$t('ph_acessories')"
                  v-model="vehicle.acessories"
                  @input="vehicle.acessories = vehicle.acessories.toUpperCase()"
                />

                <small
                  class="form-text text-muted text-left"
                >
                  Atenção: Antes de adicionar acessórios à solicitação, verifique se sua empresa possui esses itens contratados. Caso sejam incluídos acessórios não contratados, a solicitação de instalação destes será desconsiderada.
                </small>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-form"
              data-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary btn-form"
              @click="addVehicle"
              data-dismiss="modal"
              style="color: #000"
              :disabled="!canAddVehicle"
            >
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL SUCCESS -->
    <div
      class="modal fade"
      id="modalSuccess"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalSuccessLabel"
    >
      <div
        class="modal-lg modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content bg-muted">
          <div class="modal-header">
            <h5 class="modal-title" id="modalSuccessLabel">Solicitação enviada!</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Fechar"
            >
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="d-block text-center">
              Sua solicitação foi enviada com sucesso!
            </div>

            <div class="d-block text-center">
              Em breve nosso suporte entrará em contato para confirmar o agendamento do serviço.
            </div>

            <div class="d-block text-center">
              Agradecemos pelo seu contato e estamos à disposição para qualquer dúvida!
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-form"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-auto col-lg-12 mb-3" style="display: flex; justify-content: center;">
      <Recaptcha @recaptcha-is-valid="handleRecaptchaIsValid" />
    </div>

    <div class="mx-auto col-sm-8 col-lg-12 pb-3">
      <LoaderButton
        @click="send"
        class="btn-block"
        style="color: #000"
        :disabled="!canSend"
        :loading="loading"
      >
        {{ $t("send") }}
      </LoaderButton>
    </div>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import { request } from "@/lib/http";
import Combobox from "@/components/shared/ComboBox";
import Recaptcha from "@/components/shared/Recaptcha";

export default {
  name: "TrackerInstallation",
  components: {
    LoaderButton,
    Combobox,
    Recaptcha
  },

  data() {
    return {
      allResponsible: [],
      allVehicles: [],
      applicant: {
        name: "",
        email: "",
        cpf: "",
        cargo: "",
      },
      company: {
        name: "",
        cnpj: "",
      },
      service: {
        address: "",
        referencePoint: "",
        datetimeService: "",
      },
      responsible: {
        name: "",
        email: "",
        phone: "",
      },
      vehicle: {
        plate: "",
        brand: "",
        model: "",
        year: "",
        block: "",
        acessories: "",
      },
      loading: false,
      addressService: null,
      addresses: [],
      recaptchaTokenIsValid: false
    };
  },

  watch: {
    'service.address'(value) {
      if (!value) {
        return this.addresses = []
      }

      this.addressService.getPlacePredictions({ input: this.service.address }, this.displaySuggestions)
    }
  },

  computed: {
    canSend() {
      const propertiesToCheck = [
        "name",
        "cpf",
        "email",
        "cargo",
        "social_reason",
        "cnpj",
      ];

      const propertiesOk = this.checkError(propertiesToCheck);

      return (
        propertiesOk && this.allResponsible.length && this.allVehicles.length && this.recaptchaTokenIsValid
      );
    },

    canAddVehicle() {
      const propertiesVehicleToCheck = ['brand', 'model', 'year', 'plate', 'block'];

      const propertiesOk = this.checkError(['board', 'year']);

      const vehicleOk = propertiesVehicleToCheck.every(property => this.vehicle[property])

      return vehicleOk && propertiesOk;
    },

    canAddResponsible() {
      return (
        this.responsible.name &&
        (this.responsible.phone && !this.errors.has('phone')) &&
        !this.errors.has("email")
      );
    },
  },

  methods: {
    showModalAddResponsible() {
      $("#modalAddResponsible").modal("show");

      this.responsible = {
        name: "",
        email: "",
        phone: "",
      };
    },

    showModalAddVehicle() {
      $("#modalAddVehicle").modal("show");

      this.vehicle = {
        plate: "",
        brand: "",
        model: "",
        year: "",
        block: "",
        acessories: ""
      };
    },

    addResponsible() {
      this.allResponsible.push(this.responsible);
    },

    addVehicle() {
      this.allVehicles.push(this.vehicle);
    },

    removeResponsible(indexToRemove) {
      this.allResponsible = this.allResponsible.filter(
        (_, index) => index != indexToRemove
      );
    },

    removeVehicle(indexToRemove) {
      this.allVehicles = this.allVehicles.filter(
        (_, index) => index != indexToRemove
      );
    },

    async send() {
      let obj = {
        applicantName: this.applicant.name,
        applicantEmail: this.applicant.email,
        applicantCpf: this.applicant.cpf,
        applicantCargo: this.applicant.cargo,
        companyName: this.company.name,
        companyCnpj: this.company.cnpj,
        responsible: this.allResponsible,
        vehicles: this.allVehicles,
      };

      if (this.service.address) {
        obj.serviceDataAddress = this.service.address;
      }

      if (this.service.referencePoint) {
        obj.serviceDataReferencePoint = this.service.referencePoint;
      }

      if (this.service.datetimeService) {
        obj.serviceDataDatetimeService = this.service.datetimeService;
      }

      try {
        this.loading = true;

        await request({
          url: `form-request-acessories-installation`,
          method: "post",
          data: obj,
        });

        $("#modalSuccess").modal("show");

        this.vehicle = {
          plate: "",
          brand: "",
          model: "",
          year: "",
          block: "",
          acessories: "",
        };

        this.responsible = {
          name: "",
          email: "",
          phone: "",
        };

        this.applicant = {
          name: "",
          email: "",
          cpf: "",
          cargo: "",
        }

        this.company = {
          name: "",
          cnpj: "",
        }

        this.service = {
          address: "",
          referencePoint: "",
          datetimeService: "",
        }

        this.allResponsible = []
        this.allVehicles = []
      } catch (error) {
        console.log("[ERROR-SEND-FORM-ACESSORIES-INSTALLATION] => ", error);

        this.$store.dispatch('notify/error', { message: JSON.stringify(error) })
      } finally {
        this.loading = false;
      }
    },

    checkError(properties = []) {
      return properties.every((property) => !this.errors.has(property));
    },

    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        return this.addresses = []
      }

      this.addresses = predictions.map(prediction => prediction.description)
    },

    handleRecaptchaIsValid(isValid) {
      this.recaptchaTokenIsValid = isValid;
    }
  },

  mounted () {
    this.addressService = new window.google.maps.places.AutocompleteService()
  },
};
</script>
